import { get, isEmpty } from 'lodash'
import { AI_EVALUATION_STATUS } from '@edulastic/constants/const/evaluationType'

export const isAIEvaluationPresentOnActivity = (activity) => {
  if (!activity) return false
  const feedbackByAI = get(activity, 'feedbackByAI.text', '')
  return (
    !isEmpty(feedbackByAI) ||
    activity.scoreByAI != null ||
    !isEmpty(activity.rubricFeedbackByAI) ||
    activity.aiEvaluationStatus === AI_EVALUATION_STATUS.DONE
  )
}

/**
 * Teacher has approved when AI suggestion exists and a grade was committed.
 * Note: approve sets isGradedExternally=true — that must NOT exclude approved.
 */
export const isAiEvaluationApprovedOnActivity = (activity) => {
  if (!activity) return false
  if (!isAIEvaluationPresentOnActivity(activity)) return false
  if (activity.graded === false) return false

  const teacherFeedback = get(activity, 'feedback.text', '')
  return (
    activity.graded === true ||
    activity.score != null ||
    !isEmpty(teacherFeedback)
  )
}

const isAiEvaluationPendingApprovalOnActivity = (activity) => {
  if (!activity || activity.isGradedExternally) return false
  if (!isAIEvaluationPresentOnActivity(activity)) return false
  if (isAiEvaluationApprovedOnActivity(activity)) return false

  return (
    activity.aiEvaluationStatus === AI_EVALUATION_STATUS.DONE ||
    activity.graded === false ||
    !activity.graded
  )
}

export const hasAnyPendingAiEvaluationApproval = (questionActivities = []) =>
  (questionActivities || []).some(isAiEvaluationPendingApprovalOnActivity)
